import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { completeAnimalIdSignIn } from '@/features/auth/animal-id';
import { buildSigninPath } from '@/utils/return-to';

/** アニマルID からの戻り先。ログインできたら元の画面へ、できなければ理由を添えてログイン画面へ移る */
export const AnimalIdCallbackPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // 認可コードは 1 度しか使えない。開発時の StrictMode で effect が 2 回呼ばれても 1 回だけ送る
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void completeAnimalIdSignIn(searchParams).then((result) => {
      if (result.type === 'success') {
        navigate(result.returnTo ?? '/orders', { replace: true });
        return;
      }
      navigate(buildSigninPath(result.returnTo), { replace: true, state: { signInError: result.message } });
    });
  }, [navigate, searchParams]);

  return <p className="text-neutral-500">ログインしています...</p>;
};
